// extracted by mini-css-extract-plugin
export var form__button = "DownloadForm-module--form__button--3mzoB";